export const QueryKeys = {
  ListBucketContents: (resultId: string) => ['list-bucket-contents', resultId]
}
